/**
 * Trạng thái hồ sơ hiển thị
 */
export default {
  NotReturn: 0, // chưa gửi trả
  Return: 1, // đã gửi trả
}
